import {
  Feedback,
  FeedbackCategoryResponse,
  FeedbackResponse,
} from './feedback.interface';

export interface FeedbackParams {
  ordering?: string;
  page?: number;
  page_size?: number;
  status?: number;
  q?: string;
}

export interface FeedbackState {
  feedbacks: FeedbackResponse | null;
  loading: boolean;
  error: string | null;
  params: FeedbackParams | null;
}

export const initialFeedbackState: FeedbackState = {
  feedbacks: null,
  loading: false,
  error: null,
  params: null,
};

export interface FeedbackDetailState {
  feedback: Feedback | null;
  loading: boolean;
  error: any;
}

export const initialFeedbackDetailState: FeedbackDetailState = {
  feedback: null,
  loading: false,
  error: null,
};

export interface FeedbackCategoriesState {
  categories: FeedbackCategoryResponse | null;
  loading: boolean;
  error: string | null;
}

export const initialFeedbackCategoriesState: FeedbackCategoriesState = {
  categories: null,
  loading: false,
  error: null,
};

export interface AddFeedbackState {
  feedback: Feedback | null;
  loading: boolean;
  error: any | null;
  success?: boolean;
}

export const initialAddFeedbackState: AddFeedbackState = {
  feedback: null,
  loading: false,
  error: null,
  success: false,
};
